import React from "react";

const CreditCard = () => {
  return (
    <svg
      id="creditCard"
      width="143"
      height="116"
      viewBox="0 0 143 116"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M121.682 0.234935L10.8588 12.1498C4.71476 12.8103 0.2842 18.3249 0.944213 24.4639L9.71117 106.008C10.3712 112.147 15.8727 116.594 22.0167 115.933L132.84 104.018C138.984 103.358 143.415 97.8433 142.755 91.7043L133.988 10.1601C133.328 4.02115 127.826 -0.425621 121.682 0.234935ZM13.4402 23.1204L121.492 11.5036C122.254 11.4216 122.945 11.9801 123.027 12.7446L124.073 22.4743L13.2498 34.3891L12.2037 24.6594C12.1215 23.8949 12.6779 23.2024 13.4402 23.1204ZM130.259 93.0478L22.2071 104.665C21.4449 104.747 20.754 104.188 20.6718 103.424L16.4378 64.0415L127.261 52.1267L131.495 91.5088C131.578 92.2733 131.021 92.9658 130.259 93.0478ZM51.5685 78.0742L52.5647 87.3406C52.7291 88.8695 51.6163 90.2546 50.0918 90.4185L33.4614 92.2065C31.9369 92.3704 30.5551 91.2535 30.3908 89.7246L29.3945 80.4582C29.2301 78.9292 30.3429 77.5442 31.8674 77.3803L48.4979 75.5923C50.0223 75.4284 51.4041 76.5453 51.5685 78.0742ZM95.9164 73.3063L96.9126 82.5727C97.077 84.1016 95.9642 85.4867 94.4397 85.6506L63.0266 89.0279C61.5022 89.1918 60.1204 88.0749 59.956 86.5459L58.9598 77.2796C58.7954 75.7506 59.9082 74.3655 61.4327 74.2016L92.8458 70.8244C94.3702 70.6605 95.752 71.7773 95.9164 73.3063Z"
        fill="#005D7D"
      />
    </svg>
  );
};

export default CreditCard;
